import React, { Component } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faMapMarkerAlt, faAt, faQuoteLeft, faQuoteRight, faUniversity, faClock, faTrophy,
          faGraduationCap, faLaptop, faCalendarAlt, faAtom, faCode, faChalkboardTeacher,
          faIdCard, faFileAlt, faCodeBranch, faBars, faSearch, faCalendarPlus, 
          faTimes, faTrashAlt,  faEdit, faNotesMedical, faCheckDouble, faHandshake, faWalking, faHouseUser} from '@fortawesome/free-solid-svg-icons'
import Header from './common/Header';
import Foot from './home/footer/Foot';
import {connect} from 'react-redux';
import {resizeAction, Spinner_Action} from '../actions';
// import SideNav, { Toggle, Nav, NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import { Sidenav, Nav, Icon, Dropdown } from 'rsuite';
import { push } from 'react-router-redux'
import Spinner from './common/Spinner';

library.add(fab, faMapMarkerAlt, faAt, faQuoteLeft, faQuoteRight, faUniversity, faClock, faTrophy, faGraduationCap,
              faLaptop, faCalendarAlt, faAtom, faCode, faChalkboardTeacher, faIdCard, faFileAlt, faCheckDouble,
              faCodeBranch, faBars, faSearch, faCalendarPlus,  faTimes, faTrashAlt,  faEdit, faNotesMedical, faHandshake, faWalking,
              faHouseUser)

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected_key: this.props.location.pathname,
      open_keys: [],
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  
    componentDidMount() {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    }
    
    componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
    
    updateWindowDimensions() {
      this.props.resizeAction({width: window.innerWidth, height: window.innerHeight, expanded: window.innerWidth >= 700? true:false })
    }

  componentDidUpdate = (prevProp) => {
    if(this.props.location.pathname != prevProp.location.pathname){
      this.setState({
        selected_key: this.props.location.pathname
      })

      if(this.props.location.pathname.includes("research_tracks")){
        this.setState({
          open_keys: ['/csci2024/research_tracks']
        })
      }else{
        this.setState({
          open_keys: []
        })
      }
    }
  }

  sideNav_select = (key) => {
    // if(key == "photos") {
    //   window.open("https://photos.ucmss.com/", "_blank")
    // }else{
      this.setState({
        selected_key: key
      })
      this.props.push(key)
    // }
  }

  render() {
    return (
      <div>
        <div>
          {this.props.Spinner_ActionReducer.show? <Spinner />: ''}
        </div>
        <div className="r_container">
        <Header />
        <div className="side_n_content">
          {this.props.resizeActionReducer.expanded &&
          <div className="nav_div">
          <Sidenav openKeys={this.state.open_keys} activeKey={this.state.selected_key} onSelect={(e)=> this.sideNav_select(e)}>
            <Sidenav.Body>
              <Nav>

                <div className="nav_logo"> 
                  <img
                    alt=""
                    src="/static/logo.png"
                  />
                </div>

                <Nav.Item eventKey="/csci2024/">
                Home
                </Nav.Item>


                <Nav.Item eventKey="/csci2024/topics">
                Scope & List of Topics
                </Nav.Item>

                <Dropdown eventKey="/csci2024/research_tracks" title="Research Tracks" onClick={()=>{
                  let a = this.state.open_keys.length == 1? [] : ['/csci2024/research_tracks']
                  this.setState({
                    open_keys: a
                  })
                }}>
                  <Dropdown.Item eventKey="/csci2024/RTAI">RTAI</Dropdown.Item>
                  <Dropdown.Item eventKey="/csci2024/RTBD">RTBD</Dropdown.Item>
                  <Dropdown.Item eventKey="/csci2024/RTCB">RTCB</Dropdown.Item>
                  <Dropdown.Item eventKey="/csci2024/RTCC">RTCC</Dropdown.Item>
                  <Dropdown.Item eventKey="/csci2024/RTCI">RTCI</Dropdown.Item>
                  <Dropdown.Item eventKey="/csci2024/RTCS">RTCS</Dropdown.Item>
                  <Dropdown.Item eventKey="/csci2024/RTCW">RTCW</Dropdown.Item>
                  <Dropdown.Item eventKey="/csci2024/RTED">RTED</Dropdown.Item>
                  <Dropdown.Item eventKey="/csci2024/RTHI">RTHI</Dropdown.Item>
                  <Dropdown.Item eventKey="/csci2024/RTMC">RTMC</Dropdown.Item>
                  <Dropdown.Item eventKey="/csci2024/RTNA">RTNA</Dropdown.Item>
                  <Dropdown.Item eventKey="/csci2024/RTOT">RTOT</Dropdown.Item>
                  <Dropdown.Item eventKey="/csci2024/RTPC">RTPC</Dropdown.Item>
                  <Dropdown.Item eventKey="/csci2024/RTPD">RTPD</Dropdown.Item>
                  <Dropdown.Item eventKey="/csci2024/RTSC">RTSC</Dropdown.Item>
                  <Dropdown.Item eventKey="/csci2024/RTSE">RTSE</Dropdown.Item>
                </Dropdown>

                {/* <Nav.Item eventKey="4">
                Proceedings & Indexation
                </Nav.Item> */}
                <Nav.Item eventKey="/csci2024/final_papers">
                Final Papers
                </Nav.Item>
                <Nav.Item eventKey="/csci2024/schedules">
                Program/Schedules
                </Nav.Item>
                <Nav.Item eventKey="/csci2024/keynotes">
                Keynotes/Invited Lectures
                </Nav.Item>
                <Nav.Item eventKey="/csci2024/publisher">
                Publisher
                </Nav.Item>
                <Nav.Item eventKey="/csci2024/paper_submission">
                Paper Submission
                </Nav.Item>
                <Nav.Item eventKey="/csci2024/paper_review_pocess">
                Paper Review Process
                </Nav.Item>
                <Nav.Item eventKey="/csci2024/paper_categories">
                Paper Categories
                </Nav.Item>
                <Nav.Item eventKey="/csci2024/presentation_modes">
                Presentation Modes
                </Nav.Item>
                <Nav.Item eventKey="/csci2024/demography_history">
                Demography History
                </Nav.Item>
                <Nav.Item eventKey="/csci2024/committees">
                Conference Organization
                </Nav.Item>
                {/* <Nav.Item eventKey="11">
                Keynote Lectures
                </Nav.Item> */}
                <Nav.Item eventKey="/csci2024/registration">
                Registration
                </Nav.Item>
                {/* <Nav.Item eventKey="13">
                  Schedules
                </Nav.Item> */}
                <Nav.Item eventKey="/csci2024/venue">
                Venue
                </Nav.Item>
                <Nav.Item eventKey="/csci2024/authors">
                Authors of Accepted Papers
                </Nav.Item>
                <Nav.Item eventKey="/csci2024/deadlines">
                  Important Dates
                </Nav.Item>
                <Nav.Item eventKey="/csci2024/contact">
                  Contact
                </Nav.Item>
                <Nav.Item eventKey="/csci2024/career_fair">
                  Career, Job, & Education Fair
                </Nav.Item>
                {/* <Dropdown.Item divider /> */}
                <Nav.Item eventKey="/csci2024/gallery">
                  Photo Gallery
                </Nav.Item>

              </Nav>
            </Sidenav.Body>
          </Sidenav>
            </div>
            }
          <div className="content_div">
            {this.props.children}
          </div>
        </div>
        <Foot />
      </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    resizeActionReducer: state.resizeActionReducer,
    Spinner_ActionReducer: state.Spinner_ActionReducer
  }
}

const mapDispatchToProps = () => {
  return {
    push,
    resizeAction,
    Spinner_Action
  }
}
export default connect(mapStateToProps, mapDispatchToProps())(App);
